import { ConfigInitializer, ConfigInitializerService } from '@spartacus/core';
import { combineLatest, map, switchMap, firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';

import { StoreFinderConfig } from '../configs/store-finder.config';
import { BaseStoreService } from '../../services';

@Injectable()
export class GeolocationConfigInitializer implements ConfigInitializer {
  scopes = ['googleMaps'];

  constructor(
    private configInitializerService: ConfigInitializerService,
    private baseStoreService: BaseStoreService
  ) {}

  configFactory(): Promise<StoreFinderConfig> {
    return firstValueFrom(
      this.configInitializerService.getStable('backend.occ', 'context').pipe(
        switchMap(() => combineLatest([
          this.baseStoreService.getBaseStore(),
          this.baseStoreService.getGeolocationKey()
        ])),
        map(([baseStore, apiKey]) => ({
          googleMaps: { apiKey, radius: baseStore.defaultRadius }
        }))
      )
    );
  }
}
